export default {
  errorMessageTechnicalDetail: {
    display: 'block',
    fontSize: 11
  }
};
